export default __webpack_public_path__ + "static/media/nft-op-5.2ba18c44.svg";